/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, total: NonNullable<unknown> }} Builds_Comparison_PageInputs */

const id_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Halaman ${i?.page} dari ${i?.total}`)
};

const ms_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Halaman ${i?.page} daripada ${i?.total}`)
};

const da_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Side ${i?.page} af ${i?.total}`)
};

const de_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seite ${i?.page} von ${i?.total}`)
};

const en_us2_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
};

const es_es2_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.total}`)
};

const es_mx2_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.total}`)
};

const fil_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pahina ${i?.page} ng ${i?.total}`)
};

const fr_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} sur ${i?.total}`)
};

const it_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.page} di ${i?.total}`)
};

const hu_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.page}. oldal / ${i?.total}`)
};

const nl_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.page} van ${i?.total}`)
};

const no_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Side ${i?.page} av ${i?.total}`)
};

const pl_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Strona ${i?.page} z ${i?.total}`)
};

const pt_br2_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.total}`)
};

const pt_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.total}`)
};

const ro_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.page} din ${i?.total}`)
};

const fi_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sivu ${i?.page}/${i?.total}`)
};

const sv_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sida ${i?.page} av ${i?.total}`)
};

const vi_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trang ${i?.page} trên ${i?.total}`)
};

const tr_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} içinde ${i?.page}. sayfa`)
};

const cs_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stránka ${i?.page} z ${i?.total}`)
};

const bg_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Страница ${i?.page} от ${i?.total}`)
};

const ru_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Страница ${i?.page} из ${i?.total}`)
};

const uk_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сторінка ${i?.page} з ${i?.total}`)
};

const ar_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`الصفحة ${i?.page} من ${i?.total}`)
};

const hi_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पृष्ठ ${i?.page} / ${i?.total}`)
};

const th_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`หน้า ${i?.page} จาก ${i?.total}`)
};

const ja_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} ページ中 ${i?.page} ページ`)
};

const zh_cn2_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.page} 页，共 ${i?.total} 页`)
};

const zh_hant1_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.page} 頁，共 ${i?.total} 頁`)
};

const ko_builds_comparison_page = /** @type {(inputs: Builds_Comparison_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total}개 중 ${i?.page}페이지`)
};

/**
* | output |
* | --- |
* | "Page {page} of {total}" |
*
* @param {Builds_Comparison_PageInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_page = /** @type {((inputs: Builds_Comparison_PageInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_PageInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_page(inputs)
	if (locale === "ms") return ms_builds_comparison_page(inputs)
	if (locale === "da") return da_builds_comparison_page(inputs)
	if (locale === "de") return de_builds_comparison_page(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_page(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_page(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_page(inputs)
	if (locale === "fil") return fil_builds_comparison_page(inputs)
	if (locale === "fr") return fr_builds_comparison_page(inputs)
	if (locale === "it") return it_builds_comparison_page(inputs)
	if (locale === "hu") return hu_builds_comparison_page(inputs)
	if (locale === "nl") return nl_builds_comparison_page(inputs)
	if (locale === "no") return no_builds_comparison_page(inputs)
	if (locale === "pl") return pl_builds_comparison_page(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_page(inputs)
	if (locale === "pt") return pt_builds_comparison_page(inputs)
	if (locale === "ro") return ro_builds_comparison_page(inputs)
	if (locale === "fi") return fi_builds_comparison_page(inputs)
	if (locale === "sv") return sv_builds_comparison_page(inputs)
	if (locale === "vi") return vi_builds_comparison_page(inputs)
	if (locale === "tr") return tr_builds_comparison_page(inputs)
	if (locale === "cs") return cs_builds_comparison_page(inputs)
	if (locale === "bg") return bg_builds_comparison_page(inputs)
	if (locale === "ru") return ru_builds_comparison_page(inputs)
	if (locale === "uk") return uk_builds_comparison_page(inputs)
	if (locale === "ar") return ar_builds_comparison_page(inputs)
	if (locale === "hi") return hi_builds_comparison_page(inputs)
	if (locale === "th") return th_builds_comparison_page(inputs)
	if (locale === "ja") return ja_builds_comparison_page(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_page(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_page(inputs)
	return ko_builds_comparison_page(inputs)
});
export { builds_comparison_page as "builds.comparison.page" }